import VueRouter from 'vue-router'
import MainPage from '@/components/MainPage'
import cgz from '@/components/kr/qyz'
// import ContentWrapper from '@/components/ContentWrapper'
// import MEnter from '@/common/MEnter'
// import YouthScienceList from '@/components/youth_science/YouthScienceList'
// import YouthDetail from '@/components/youth_science/YouthDetail'
// import EduScienceList from '@/components/eud_science/EduScienceList'
// import EduCompanyDetail from '@/components/eud_science/EduCompanyDetail'
// import LiveList from '@/components/live/LiveList'
// import LiveDetail from '@/components/live/LiveDetail'
// import OnlineMeeting from '@/components/online_meeting/OnlineMeeting'
// import OnlineMeetingDetail from '@/components/online_meeting/OnlineMeetingDetail'
// import GameList from '@/components/games/GameList'
// import GameDetail from '@/components/games/GameDetail'
// import SearchPage from '@/components/searchPage'
import KrpanoView from '@/components/KrpanoView'
// import StarLight from '@/components/starlight/index'
// import PreFace from '@/components/starlight/preface'
// import breakingNews from '@/components/starlight/breakingNews'
// import retrospect from '@/components/starlight/retrospect'
// import starlit from '@/components/starlight/starlit'
// import bigMap from '@/components/bigMap'
// import starDetail from "@/components/starlight/starDetail";
const routes = [
  {
    path: '/',
    component: MainPage,
    name: 'main'
  },
  // {
  //   path: '/web',
  //   component: ContentWrapper,
  //   children: [
  //     {
  //       path: '',
  //       component: YouthScienceList,
  //       name: 'web',
  //       redirect: { name: 'youth_science', params: { subpath: 'achievement' } }
  //     },
  //     {
  //       path: 'menter',
  //       component: MEnter,
  //       name: 'menter'
  //     },
  //     // {
  //     //   path: 'starlight',
  //     //   component: StarLight,
  //     //   name: 'starlight',
  //     //   redirect: { name: 'preface' },
  //     //   children: [
  //     //     {
  //     //       path: 'preface',
  //     //       component: PreFace,
  //     //       name: 'preface'
  //     //     },
  //     //     {
  //     //       path: 'breakingNews',
  //     //       component: breakingNews,
  //     //       name: 'breakingNews'
  //     //     },
  //     //     {
  //     //       path: 'retrospect',
  //     //       component: retrospect,
  //     //       name: 'retrospect'
  //     //     },
  //     //     {
  //     //       path: 'starlit',
  //     //       component: starlit,
  //     //       name: 'starlit'
  //     //     },
  //     //     {
  //     //       path: 'starDetail/:id',
  //     //       component: starDetail,
  //     //       name: 'starDetail'
  //     //     }
  //     //   ]
  //     // },
  //     {
  //       path: 'youth_science/:subpath',
  //       component: YouthScienceList,
  //       name: 'youth_science'
  //     },
  //     {
  //       path: 'youth_science/:subpath/:id',
  //       component: YouthDetail,
  //       name: 'youth_detail'
  //     },
  //     {
  //       path: 'eud_science',
  //       redirect: { name: 'eud_science', params: { subpath: 'edu' } }
  //     },
  //     {
  //       path: 'eud_science/:subpath',
  //       component: EduScienceList,
  //       name: 'eud_science'
  //     },
  //     {
  //       path: 'eud_science/:subpath/:id',
  //       component: EduCompanyDetail,
  //       name: 'company_detail'
  //     },
  //     // {
  //     //   path: 'live',
  //     //   component: LiveList,
  //     //   name: 'live'
  //     // },
  //     // {
  //     //   path: 'live/:id',
  //     //   component: LiveDetail,
  //     //   name: 'live_detail'
  //     // },
  //     // {
  //     //   path: 'online_meeting',
  //     //   component: OnlineMeeting,
  //     //   name: 'online_meeting'
  //     // },
  //     // {
  //     //   path: 'online_meeting/:subpath/:id',
  //     //   component: OnlineMeetingDetail,
  //     //   name: 'online_meeting_detail'
  //     // },
  //     // {
  //     //   path: 'game',
  //     //   component: GameList,
  //     //   name: 'game'
  //     // },
  //     // {
  //     //   path: 'game/:id',
  //     //   component: GameDetail,
  //     //   name: 'game_detail'
  //     // },
  //     {
  //       path: 'search',
  //       component: SearchPage,
  //       name: 'search'
  //     },
  //     {
  //       path: 'bigMap',
  //       component: bigMap,
  //       name: 'bigMap'
  //     },
  //   ]
  // },
  {
    path: '/cgz',
    component: cgz,
    name: 'cgz',
  },
  {
    path: '/kr_view',
    component: KrpanoView,
    name: 'kr_view',
  },
  {
    path: '*',
    redirect: { name: 'main' }
  }
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  // base: "/2022_kyzx/",
  routes: routes
})

export default router
